* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:host {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-shrink: 0;

  padding: $size-space-md;
  width: 320px;

  border: 2px solid transparent;
  border-radius: $size-radius-sm;

  transition: all linear 0.15s;

  .best-offer-badge {
    position: absolute;
    z-index: 5;
    left: $size-space-md;
    top: -12px;
  }

  .title-wrapper {
    display: flex;
    align-items: center;

    margin-bottom: 12px;

    smart-radio {
      opacity: 0 !important;
      margin-right: $size-space-sm;
    }
  }

  .title {
    display: flex;
    align-items: center;

    smart-text{
      margin-bottom: -2px;
    }

    smart-text.plan-label {
      margin-right: 6px;
      margin-bottom: 0;
      &::part(text-element){
        font-family: $font-family-primary;
      }

      b {
        font-weight: 900;
        font-family: $font-family-primary;
      }
    }
  }

  smart-text.description {
    margin-bottom: $size-space-sm;
    align-items: center;

    @media (min-width: 780px) {
      min-height: 70px;
    }
  }

  smart-text.old-price::part(text-element) {
    text-decoration-line: line-through;
  }

  .info-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    width: 100%;
    height: 112px;

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      height: 64px;
    }
  }

  smart-text.fidelity,
  smart-text.annuity,
  smart-text.membership {
    margin: $size-space-xxs 0;
  }

  .new-price {
    display: flex;
    align-items: flex-end;

    margin: $size-space-xxs 0;

    smart-text.new-price-amount::part(text-element){
      line-height: $size-typography-headline-5 !important;
    }

    smart-text.price-discount::part(text-element){
      margin-left: 8px;

      color: $color-action-success-light;
    }
  }

  smart-collapse.content{
    padding-top: $size-space-md;
    margin-top: auto;
  }

  .scarcity-badged {
    display: flex;
    align-content: center;
    justify-content: center;
    flex-shrink: 0;
    
    margin-bottom: 16px;
    padding: 5px;
    
    background-color: #fbeef0;
    font-family: $font-family-primary;
    font-size: 13px;
    color: #a72534;
    font-weight: bold;
    border-radius: 4px;
  }
}

smart-text.installments-disclaimer {
  margin-bottom: 16px;
}
smart-text.installments-disclaimer::part(text-element){
  b {
    font-family: $font-family-primary;
    font-weight: 900;
  }
}

:host(.isClickabe){
  cursor: pointer;
}

:host(.selected){
  border-color: $color-base-brand-yellow !important;
}

:host(.light) {
  background-color: $color-base-brand-white;
  border-color:  $color-base-gray-gray-7;

  smart-text.plan-label::part(text-element),
  smart-text.plan-name::part(text-element),
  smart-text.new-price-amount::part(text-element),
  smart-text.new-price-recurrency::part(text-element){
    color: $color-typography-typo-88;
  }

  smart-text.description::part(text-element),
  smart-text.offer-disclaimer::part(text-element),
  smart-text.old-price::part(text-element),
  smart-text.fidelity::part(text-element),
  smart-text.annuity::part(text-element),
  smart-text.membership::part(text-element),
  smart-text.installments-disclaimer::part(text-element) {
    color: $color-typography-typo-64;
  }

  smart-text.price-discount::part(text-element){
    color: $color-action-success-dark;
  }
}
:host(.dark) {
  background-color: $color-base-gray-gray-5;

  smart-text.plan-label::part(text-element),
  smart-text.plan-name::part(text-element),
  smart-text.new-price-amount::part(text-element),
  smart-text.new-price-recurrency::part(text-element),
  smart-text.description::part(text-element),
  smart-text.offer-disclaimer::part(text-element),
  smart-text.old-price::part(text-element),
  smart-text.fidelity::part(text-element),
  smart-text.annuity::part(text-element),
  smart-text.membership::part(text-element),
  smart-text.disclaimer::part(text-element),
  smart-collapse::part(text-element),
  smart-text.installments-disclaimer::part(text-element) {
    color: $color-typography-typo-fff;
  }
}
:host(.hydrated) {
  smart-radio {
    opacity: 1 !important;
  }
}

.cta-button {
  margin-top: 16px;
  width: 100%;
}

.card-content {
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  margin-top: 16px;

  width: 100%;
}
